import { createReducer } from '../../app/common/util/reducerUtil';
import { DELETE_SAVED_CARD, LIST_SAVED_CARDS } from './CardsConstants';

const initialState = {};

export const deleteCard = (state, payload) => {
  return {
    ...state,
    deleteCard: payload,
  }
};

export const listCards = (state, payload) => {
  return {
    ...state,
    fetchedCards: payload,
  }
};

export default createReducer(initialState, {
  [LIST_SAVED_CARDS]: listCards,
  [DELETE_SAVED_CARD]: deleteCard,
});
